<div class="card card-cascade d-print-block-visible">
  <div class="view gradient-card-header primary-gradient white-text">
    <h3 class='h3-responsive text-center'>{{getTitle()}}</h3>
  </div>
  <div class="card-body pl-1 pr-1 pl-sm-2 pr-sm-2" *ngFor="let scaleResult of ScaleResults;index as index; last as last;">
    <div class="view gradient-card-header secondary-gradient white-text">
      <h3 class='h3-responsive text-center'>{{scaleResult.scale?.name}}</h3>
    </div>
    <div class='table table-striped col'>
      <div class='table-header row secondary-color text-white mt-3'>
        <div class="cell-data d-none d-sm-block col-7 col-md-8">Question</div>
        <div class="cell-data d-none d-sm-block col-2 col-md-2">Answer</div>
        <div class="cell-data d-none d-sm-block col-2 col-md-2 text-center">Action</div>
      </div>
      <div *ngFor="let question of getQuestionsForScaleResult(scaleResult)"
        class="row">
        <div data-label="Question" class="col-12 col-sm-7 col-md-8 cell-data prompt">
          <span class="d-block d-sm-none view primary-gradient white-text text-center h6-responsive p-2 mb-2">Question</span>
          <em class="text-center text-sm-left">{{question.prompt}}</em>
        </div>
        <div data-label="Answer" class="col-12 col-sm-2 col-md-2 cell-data answer p-2 mb-2 text-center text-sm-left">
          <span class="d-block d-sm-none view primary-gradient white-text text-center h6-responsive p-2 mb-2">Answer</span>
          {{question.answerDisplayText}}
          <div class="d-inline-block" *hasPermission="'SuperUser'">({{question.computedScore}})</div>
        </div>
        <div data-label="Action" class="cell-data col-12 col-sm-2 col-md-2 text-center mt-xs-0">
          <a *ngIf="hasAction(question)" (click)="handleAction(question)" class="btn btn-sm btn-secondary">{{getActionLabel(question)}}</a></div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/reports/report-items/question-action-list/question-action-list.component.html